<template>
  <div class="list">
    <header>
      <a-row class="header">
        <a-col :span="3" class="header-right">
          <i @click="$router.go(-1)"></i>
        </a-col>
        <a-col :span="18" class="header-title">
          <span class="over-hide">{{ tag }}</span>
        </a-col>
        <a-col :span="3" class="header-left">
          <i class="catalog" @click="show_catalog"></i>
        </a-col>
      </a-row>
    </header>
    <mescroll-vue ref="mescroll" @init="mescrollInit" :up="mescrollUp">
      <div v-if="datas.length != 0">
        <div class="content" v-for="(data, index) in datas" :key="index">
          <div class="content-img">
            <img :src="data.img" alt @click="watch(data, index)" />
            <div
              :class="data.is_watch == 0 ? 'play' : 'replay'"
              @click="watch(data, index)"
            ></div>
            <div class="watched" v-show="data.is_watched == 1">
              {{ $t("columnVideo.Watched") }}
            </div>
          </div>
          <h1>{{ data.name }}</h1>
          <h2 class="over-hide">
            {{ data.author }}
            <i v-if="data.author != ''">|</i>
            {{ data.category_name }}
          </h2>
          <div class="showtotal detailed-introduce">
            <div class="intro-content" ref="desc" :title="data.info">
              <span class="merchant-desc" v-text="data.info"></span>
            </div>
          </div>
          <div class="fold" @click="showTotalIntro(index)">
            <i></i>
            <span>{{ $t("columnVideo.more") }}</span>
          </div>
          <div class="info">
            <h4>{{ data.publish_at }}</h4>
            <div class="right">
              <div class="watched">
                <i></i>
                {{ data.click_num }}
              </div>
              <div class="praise" @click="praised(data, index)">
                <i :class="data.is_favorite == 0 ? 'unfav' : 'faved'"></i>
                {{ data.favorite_num }}
              </div>
            </div>
          </div>
          <div class="audio-row" v-show="data.audio_url">
            <audio
              :src="data.audio_url"
              v-on:ended="audio_end(data, index)"
            ></audio>
            <div class="audio-img">
              <i></i>
              {{ $t("columnVideo.Audio") }}
            </div>
            <input
              type="checkbox"
              class="audio-ctr play"
              @click="change(data, index)"
            />
            <div class="current-time" v-if="data.currentTime == -1">00:00</div>
            <div class="current-time" v-else>{{ data.currentTime }}</div>
            <div
              class="progress-bar-bg progressBarBg"
              @mousedown="progress($event, data, index)"
            >
              <span
                class="progressDot"
                :style="{ left: data.value * 100 + '%' }"
                v-if="data.value != -1"
              ></span>
              <span class="progressDot" v-else></span>
              <div
                class="progress-bar progressBar"
                :style="{ width: data.value * 100 + '%' }"
                v-if="data.value != -1"
              ></div>
              <div class="progress-bar progressBar" v-else></div>
            </div>
            <div class="duration" v-if="data.duration == -1"></div>
            <div class="duration" v-else>{{ data.duration }}</div>
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        <div v-show="isShow">
          <div class="no-img"></div>
          <h5>{{ $t("columnVideo.NoContent") }}</h5>
        </div>
      </div>
    </mescroll-vue>
    <div class="fixed-video-box" v-if="video_show" @touchmove.prevent>
      <div class="box-pos">
        <MyAliplayer
          :video1="video"
          :videoHeight="videoHeight"
          :videoDetail="videoDetail"
          :video_id="video_id"
        ></MyAliplayer>
        <div class="close-img" @click="close"></div>
      </div>
    </div>
    <!-- 目录 -->
    <div class="n-class-slide cur">
      <!--  -->
      <div class="bg" @click="hide" @touchmove.stop.prevent></div>
      <a href="javascript:" class="class-ctrl cur" @click="show_catalog"></a>
      <div class="n-class-box">
        <!-- 二级目录 -->
        <div class="class-2" v-show="show_c2 == 1" ref="classTwo">
          <div class="class-4">
            <a
              href="javascript:"
              @click="chose_id(catalog_id, 1)"
              class="second_all"
              >{{ $t("columnVideo.All") }}</a
            >
          </div>
          <a
            href="javascript:"
            v-for="cl2 in second_catalog"
            :key="cl2.id"
            @click="chose_id(cl2.id, 0)"
            class="over-hide"
            >{{ cl2.name }}</a
          >
        </div>
        <!-- 一级目录 -->
        <div class="class-1" ref="allPart">
          <!-- 全部分类 -->
          <div class="class-3">
            <a href="javascript:" class="all" @click="chose_id(-1, 0)">{{
              $t("columnVideo.Categories")
            }}</a>
          </div>
          <div class="class-5">
            <div v-for="(cl, index) in first_catalog" :key="index">
              <div class="line"></div>
              <a
                href="javascript:"
                @click="chose_class(index + 1, cl)"
                class="over-hide"
              >
                <span v-if="cl.child.length != 0"></span>
                {{ cl.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import MyAliplayer from "../../components/MyAliplayer/index_column_video";
import mixin from "./mixins";

export default {
  data() {
    return {
      tag: "",
      datas: [],
      mescroll: null,
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.get_video_list,
        page: {
          num: 0, // 当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10, // 每页数据条数,默认10
        },
        htmlNodata:
          '<p class="upwarp-nodata">' +
          this.$t("columnVideo.noMoreData") +
          "</p>",
      },
      video: {
        VideoId: 1,
        source:
          "https://vod.olympicchannel.com/NBCR_Production_-_OCS/233/968/GEPH-ONTHERECS02E015C-_E17101101_master.m3u8",
        Duration: "04:11",
      },
      videoHeight: "3.6rem",
      video_show: false,
      videoDetail: "",
      // 目录
      slide: false,
      first_catalog: [],
      second_catalog: [],
      catalog_id: 0,
      show_c2: 0,
      // height: "1.7rem",
      isShow: false,
      repeat_praise: true,
      scrollTop: 0, // 记录列表滚动距离
      localData: {},
      watch_num: 1,
    };
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    MyAliplayer,
  },
  created() {
    //  this.$i18n.locale = "zh";
  },
  mounted() {
    // 页面失去焦点
    window.onblur = () => {
      this.closeAllAudio();
    };
    // 判断当前页面是否被激活或浏览器进入后台运行
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.closeAllAudio();
      }
    });
    // document.title = this.$t("public.Column");
  },
  watch: {
    datas() {
      this.$nextTick(() => {
        // console.log('nextTick');
        let rem = parseFloat(this.getRem());
        //  console.log("watch 中的rem", rem);
        for (var i = 0; i < this.datas.length; i++) {
          let descHeight = window
            .getComputedStyle(this.$refs.desc[i])
            .height.replace("px", "");
          // console.log(descHeight);
          if (descHeight > 2 * rem) {
            // 显示展开收起按钮
            $(".fold").eq(i).show();
          } else {
            // 不显示展开收起按钮
            $(".fold").eq(i).hide();
          }
        }
      });
    },
  },
  methods: {
    getRem() {
      const defaultRem = 16;
      let winWidth = window.innerWidth;
      // console.log("winWidth:" + winWidth);
      let rem = (winWidth / 375) * defaultRem;
      return rem;
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    get_video_list(page, mescroll) {
      var url = "index.php/mobile/column/list";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        type: "video",
        size: page.size,
        page: page.num,
        tags_id: this.$route.query.id,
        category_id: this.catalog_id,
      };
      this.$axios.post(url, params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          this.tag = res.data.result.tags.name;
          if (page.num == 1) {
            this.datas = [];
          }
          this.datas = this.datas.concat(res.data.result.data);
          for (var i = 0; i < this.datas.length; i++) {
            this.datas[i]["is_watch"] = 0;
            if (
              localStorage.getItem(
                "video_" +
                  this.$route.query.id +
                  "_" +
                  this.datas[i].resources_id
              ) != null
            ) {
              // 为true时
              var localDtata = JSON.parse(
                localStorage.getItem(
                  "video_" +
                    this.$route.query.id +
                    "_" +
                    this.datas[i].resources_id
                )
              );
              this.datas[i]["duration"] = localDtata.duration;
              this.datas[i]["currentTime"] = localDtata.currentTime;
              this.datas[i]["value"] = localDtata.value;
            } else {
              this.datas[i]["duration"] = -1;
              this.datas[i]["currentTime"] = -1;
              this.datas[i]["value"] = -1;
            }
          }
          this.isShow = true;
          this.$nextTick(() => {
            mescroll.endByPage(
              res.data.result.pages.data_count,
              res.data.result.pages.page_count
            );
          });
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    showTotalIntro(index) {
      // 背景图的切换
      $(".fold").eq(index).toggleClass("unfold");
      // 展开，收起
      $(".fold").eq(index).find("span").text() == this.$t("columnVideo.more")
        ? $(".fold")
            .eq(index)
            .find("span")
            .text(this.$t("columnVideo.collapse"))
        : $(".fold").eq(index).find("span").text(this.$t("columnVideo.more"));
      // 内容切换
      if ($(".showtotal").eq(index).hasClass("detailed-introduce")) {
        $(".showtotal")
          .eq(index)
          .removeClass("detailed-introduce")
          .addClass("total-introduce");
      } else {
        $(".showtotal")
          .eq(index)
          .removeClass("total-introduce")
          .addClass("detailed-introduce");
      }
    },
    praised(data, index) {
      if (this.repeat_praise) {
        this.repeat_praise = false;
        var url = "index.php/mobile/favorite/item";
        var params = {
          sys_id: localStorage.getItem("_sys_id"),
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          language: localStorage.getItem("_user_data_language"),
          item: data.resources_id,
          type: 14,
        };
        this.$axios.post(url, params).then((res) => {
          // console.log(res);
          this.repeat_praise = true;
          if (res.data.code == 0) {
            if (res.data.result.is_favorite == 1) {
              this.$toast(this.$t("columnVideo.success"));
              this.datas[index].is_favorite = 1;
              this.datas[index].favorite_num++;
              this.$store.commit("column_video/is_favorite", 1);
            } else {
              this.$toast(this.$t("columnVideo.del"));
              if (this.datas[index].favorite_num > 0) {
                this.datas[index].favorite_num--;
              } else {
                this.datas[index].favorite_num = 0;
              }
              this.datas[index].is_favorite = 0;
              this.$store.commit("column_video/is_favorite", 0);
            }
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
    change(data, index) {
      var checked_row = $(".audio-row")
        .eq(index)
        .find("input[type=checkbox]")[0].checked;
      var all_row = $(".audio-row");
      if (checked_row) {
        for (var i = 0; i < all_row.length; i++) {
          all_row
            .eq(i)
            .find(".audio-ctr")
            .removeClass("paused")
            .addClass("play");
          all_row.eq(i).find("input[type=checkbox]")[0].checked = false;
          // 暂停播放音频
          if (!$("audio").get(i).paused) {
            $("audio").get(i).pause();
          }
        }
        $("audio").get(index).play();

        // 获取音频时间
        var playPromise = $("audio").get(index).play();
        if (playPromise != undefined) {
          // 提交学时
          if (this.startSeekTime !== null) {
            this.submitStudyTime(this.video_id);
          } else {
            this.timerFun();
          }
          this.video_id = data.resources_id;
          this.seekTimer = 0;
          this.startSeekTime = Date.parse(new Date()) / 1000;

          playPromise
            .then(() => {
              if (
                localStorage.getItem(
                  "video_" + this.$route.query.id + "_" + data.resources_id
                ) != null
              ) {
                if (
                  JSON.parse(
                    localStorage.getItem(
                      "video_" + this.$route.query.id + "_" + data.resources_id
                    )
                  ).currentTime != -1
                ) {
                  $("audio").get(index).currentTime = this.timeToSeconds(
                    JSON.parse(
                      localStorage.getItem(
                        "video_" +
                          this.$route.query.id +
                          "_" +
                          data.resources_id
                      )
                    ).currentTime
                  );
                }
              }
              $(".audio-row")
                .eq(index)
                .find(".audio-ctr")
                .removeClass("play")
                .addClass("paused");
              $(".audio-row")
                .eq(index)
                .find("input[type=checkbox]")[0].checked = true;
              // 音频播放增加一次
              this.add_click(data, index);
              $(".duration")
                .eq(index)
                .text(this.secondsToTime($("audio").get(index).duration));
              this.localData.duration = this.secondsToTime(
                $("audio").get(index).duration
              );
              // 进度条
              var current_audio = $("audio").get(index);
              current_audio.addEventListener("timeupdate", () => {
                $(".current-time")
                  .eq(index)
                  .text(this.secondsToTime($("audio").get(index).currentTime));
                this.localData.currentTime = this.secondsToTime(
                  $("audio").get(index).currentTime
                );
                var value = current_audio.currentTime / current_audio.duration;
                this.localData.value = value;
                $(".progressBar")
                  .eq(index)
                  .css("width", value * 100 + "%");
                $(".progressDot")
                  .eq(index)
                  .css("left", value * 100 + "%");
                localStorage.setItem(
                  "video_" + this.$route.query.id + "_" + data.resources_id,
                  JSON.stringify(this.localData)
                );
              });
            })
            .catch(() => {
              this.$toast(this.$t("columnVideo.error"));
            });
        }
      } else {
        // 提交学时
        if (this.startSeekTime !== null) {
          this.submitStudyTime(data.resources_id);
        }
        this.seekTimer = 0;
        this.startSeekTime = null;
        this.clearTimer();

        $(".audio-row")
          .eq(index)
          .find(".audio-ctr")
          .removeClass("paused")
          .addClass("play");
        $(".audio-row")
          .eq(index)
          .find("input[type=checkbox]")[0].checked = false;
        // 暂停播放音频
        $("audio").get(index).pause();
      }
    },
    add_click(data) {
      var url = "index.php/mobile/column/add-click-num";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        resources_id: data.resources_id,
      };
      this.$axios.post(url, params).then((res) => {
        if (res.data.code == 0) {
          data.click_num++;
          this.$store.commit("column_video/watched_num", this.watch_num++);
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    secondsToTime(secs) {
      var hoursDiv = secs / 3600;
      var hours = Math.floor(hoursDiv);
      var minutesDiv = (secs % 3600) / 60;
      var minutes = Math.floor(minutesDiv);
      var seconds = Math.ceil((secs % 3600) % 60);
      if (seconds > 59) {
        seconds = 0;
        minutes = Math.ceil(minutesDiv);
      }
      if (minutes > 59) {
        minutes = 0;
        hours = Math.ceil(hoursDiv);
      }
      if (isNaN(hours)) {
        return "";
      }
      return (
        (hours == 0
          ? ""
          : hours > 0 && hours.toString().length < 2
          ? "0" + hours + ":"
          : hours + ":") +
        (minutes.toString().length < 2 ? "0" + minutes : minutes) +
        ":" +
        (seconds.toString().length < 2 ? "0" + seconds : seconds)
      );
    },
    timeToSeconds(time) {
      var s = null;
      if (time.split(":").length == 3) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let sec = time.split(":")[2];
        s = Number(hour * 3600) + Number(min * 60) + Number(sec);
      } else if (time.split(":").length == 2) {
        let min = time.split(":")[0];
        let sec = time.split(":")[1];
        s = Number(min * 60) + Number(sec);
      }
      return s;
    },
    progress(e, data, index) {
      // 点击进度条跳到指定点播放
      // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处（简直不能忍！！）
      // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
      if ($(".audio-row").eq(index).find(".audio-ctr").hasClass("paused")) {
        var pgsWidth = $(".progress-bar-bg").eq(index).width();
        var rate = e.offsetX / pgsWidth;
        $(".progressBar")
          .eq(index)
          .css("width", rate * 100 + "%");
        $(".progressDot")
          .eq(index)
          .css("left", rate * 100 + "%");
        $("audio").get(index).currentTime = Math.floor(
          $("audio").get(index).duration * rate
        );
        this.localData.currentTime = Math.floor(
          $("audio").get(index).duration * rate
        );
        localStorage.setItem(
          "video_" + this.$route.query.id + "_" + data.resources_id,
          JSON.stringify(this.localData)
        );
      }
    },
    audio_end(data, index) {
      // 提交学时
      if (this.startSeekTime !== null) {
        this.submitStudyTime(data.resources_id);
      }
      this.seekTimer = 0;
      this.startSeekTime = null;
      this.clearTimer();

      $(".audio-row")
        .eq(index)
        .find(".audio-ctr")
        .removeClass("paused")
        .addClass("play");
      $(".audio-row").eq(index).find("input[type=checkbox]")[0].checked = false;
      this.localData.currentTime = -1;
      this.localData.value = -1;
      localStorage.setItem(
        "video_" + this.$route.query.id + "_" + data.resources_id,
        JSON.stringify(this.localData)
      );
    },
    watch(data, index) {
      if (data.res_time_status == "3") {
        return this.$toast(this.$t("learningCamp.ResourcesExpired"));
      } else if (data.res_time_status == "1") {
        return this.$toast("资源未生效");
      } else if (data.res_time_status == "4") {
        return this.$toast("资源未授权或资源已删除");
      }
      // 停止音频
      // 暂停播放所有音频
      this.closeAllAudio();
      // 遮盖层
      this.video_show = true;
      this.add_click(data, index);
      this.videoDetail = data.resource_hash;
      this.video_id = data.resources_id;
    },
    close() {
      this.video_show = false;
    },

    show_catalog(cid) {
      this.slide = !this.slide;
      if (this.slide) {
        $(".n-class-slide").show();
        $(".n-class-box").addClass("cur");
        // 第一次的时候调接口
        if (this.first_catalog.length == 0) {
          this.get_catalog();
        }
      } else {
        $(".n-class-slide").hide();
        $(".n-class-box").removeClass("cur");
        // 点击全部时， 把二级页面收起
        if (cid == -1) {
          $(".class-1").find("a").removeClass("cur");
          $(".n-class-box").width("3.5rem");
          this.show_c2 = 0;
        }
      }
    },
    get_catalog() {
      var url = "index.php/mobile/column/categorys";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        type: "video",
        tags_id: this.$route.query.id,
      };
      this.$axios.post(url, params).then((res) => {
        if (res.data.code == 0) {
          this.first_catalog = res.data.result.list;
          this.second_catalog = this.first_catalog[0].child;
          // 高度
          // var arr = [];
          // this.first_catalog.map((v, i) => {
          //   if (v.child) {
          //     arr.push(v.child.length);
          //   } else {
          //     arr.push(0);
          //   }
          //   return arr;
          // });

          // 添加touchmove.prevent;

          if (
            $(".class-1").height() >
            $(".class-3").height() * (this.first_catalog.length + 1)
          ) {
            this.$refs.allPart.addEventListener("touchmove", function (e) {
              e.preventDefault();
            });
          }
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    chose_id(cid) {
      // 消失
      this.show_catalog(cid);
      if (cid != -1) {
        this.catalog_id = cid;
      }
      this.mescroll.resetUpScroll(true); // 触发下拉刷新的回调,加载第一页的数据
    },
    chose_class(index, item) {
      // $('.class-1') 按钮样式
      $(".class-1").find("a").removeClass("cur");
      $(".class-1").find("a").eq(index).addClass("cur");
      $(".n-class-box").width("7rem");
      if (item.child.length != 0) {
        this.show_c2 = 1; // 二级页面展示
        this.second_catalog = item.child;
        // 二级目录添加touchmove.prevent
        if (
          $(".class-1").height() >
          $(".class-3").height() * (this.second_catalog.length + 2)
        ) {
          this.$refs.classTwo.addEventListener("touchmove", function (e) {
            e.preventDefault();
          });
        } else {
          this.$refs.classTwo.removeEventListener("touchmove", function (e) {
            e.preventDefault();
          });
        }
      } else {
        this.chose_id(item.id);
      }
    },
    hide() {
      this.slide = !this.slide;
      $(".n-class-slide").hide();
    },
    // 关闭所有音频
    closeAllAudio() {
      var all_row = $(".audio-row");
      for (var i = 0; i < all_row.length; i++) {
        all_row.eq(i).find(".audio-ctr").removeClass("paused").addClass("play");
        all_row.eq(i).find("input[type=checkbox]")[0].checked = false;
        // 暂停播放音频
        if (!$("audio").get(i).paused) {
          $("audio").get(i).pause();
          // 提交学时
          if (this.startSeekTime !== null) {
            this.submitStudyTime(this.datas[i].resources_id);
          }
          this.seekTimer = 0;
          this.startSeekTime = null;
          this.clearTimer();
        }
      }
    },
  },
  beforeDestroy() {
    this.closeAllAudio();
  },
};
</script>
<style scoped lang="less">
.mescroll {
  position: fixed;
  top: 0.7rem;
}
/*隐藏掉滚动条*/
.mescroll::-webkit-scrollbar {
  display: none;
}
header {
  height: 0.7rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.23rem;
      height: 0.03rem;
      background: #999;
      vertical-align: middle;
      margin: 0 0.14rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.33rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
      vertical-align: middle;
    }
  }
  .header-left {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .catalog {
      display: inline-block;
      width: 0.4rem;
      height: 0.3rem;
      background: url("../../assets/img/new/menu.png") no-repeat center/contain;
      background-size: 100%;
      vertical-align: middle;
      position: relative;
    }
  }
}
.list {
  width: 100%;
  height: 100%;
  .content {
    margin: 0.2rem;
    padding-bottom: 0.38rem;
    background: #f6f6f6;
    .content-img {
      padding: 0.35rem 0.2rem;
      position: relative;
      img {
        width: 100%;
        height: 3.55rem;
      }
      .watched {
        color: #fff;
        font-size: 0.2rem;
        position: absolute;
        top: 0.6rem;
        background: #4aa854;
        padding: 0.05rem 0.2rem;
        border-radius: 0 2rem 2rem 0;
      }
      .play {
        width: 1.14rem;
        height: 1.14rem;
        background: url("../../assets/img/column_video/play.png") no-repeat
          center/contain;
        background-size: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.57rem;
        margin-left: -0.57rem;
      }
      .replay {
        width: 1.14rem;
        height: 1.14rem;
        background: url("../../assets/img/column_video/replay.png") no-repeat
          center/contain;
        background-size: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.57rem;
        margin-left: -0.57rem;
      }
    }
    h1 {
      margin: 0 0.2rem;
      font-size: 0.3rem;
      font-weight: bold;
    }
    h2 {
      margin: 0.1rem 0.2rem;
      font-size: 0.22rem;
      vertical-align: middle;
      color: #666;
      i {
        margin: 0 0.15rem;
      }
    }
    .total-introduce {
      height: auto;
      overflow: hidden;
      font-size: 0.26rem;
      margin: 0 0.2rem;
      .intro-content {
        .merchant-desc {
          width: 100%;
          line-height: 0.4rem;
        }
      }
    }
    .detailed-introduce {
      font-size: 0.26rem;
      overflow: hidden;
      margin: 0.1rem 0.2rem;
      position: relative;
      .intro-content {
        // 最大高度设为2倍的行间距
        max-height: 0.8rem;
        line-height: 0.4rem;
        word-wrap: break-word;
        /*强制打散字符*/
        word-break: break-all;
        overflow: hidden;
        .merchant-desc {
          width: 100%;
          line-height: 0.4rem;
        }
        &:after,
      // 这是展开前实际显示的内容
      &:before {
          content: attr(title);
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        // 把最后最后一行自身的上面三行遮住
        &:before {
          display: block;
          overflow: hidden;
          max-height: 0.8rem;
        }
        &:after {
          overflow: hidden;
          height: 0.8rem;
          background: #f6f6f6;
          display: -webkit-box;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
          /* autoprefixer: on */

          /*截取行数*/
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          /*! autoprefixer: off */
          -webkit-box-sizing: border-box;
          /* autoprefixer: on */

          box-sizing: border-box;
          /*尾部留空字符数*/
          padding-right: 0.5em;
        }
      }
    }
    .fold {
      z-index: 11;
      margin: 0 0.2rem;
      i {
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        background: url("../../assets/img/column_video/show.png") no-repeat 0;
        background-size: 100%;
        vertical-align: middle;
        margin-top: -0.02rem;
      }
      span {
        color: #005587;
        font-size: 0.22rem;
      }
    }
    .unfold {
      i {
        background: url("../../assets/img/column_video/hide.png") no-repeat 0;
        background-size: 100%;
      }
    }
    .info {
      margin: 0.2rem 0.2rem 0 0.2rem;
      padding-bottom: 0.2rem;
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 0.22rem;
        color: #666;
      }
      .right {
        display: flex;
        justify-content: center;
        font-size: 0.22rem;
        .watched {
          margin-right: 0.2rem;
          min-width: 0.6rem;
          i {
            display: inline-block;
            width: 0.3rem;
            height: 0.25rem;
            background: url("../../assets/img/column_video/watched.png")
              no-repeat center/contain;
            background-size: 100%;
            // vertical-align: text-bottom;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
        }
        .praise {
          min-width: 0.6rem;
          i {
            display: inline-block;
            width: 0.22rem;
            height: 0.25rem;
          }
          .unfav {
            background: url("../../assets/img/column_video/unfav.png") no-repeat
              center/contain;
            background-size: 100%;
            // vertical-align: text-bottom;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
          .faved {
            background: url("../../assets/img/column_video/faved.png") no-repeat
              center/contain;
            background-size: 100%;
            // vertical-align: text-bottom;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
        }
      }
    }
    .audio-row {
      margin: 0 0.3rem;
      padding: 0.15rem 0.05rem;
      border-radius: 0.1rem;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .duration {
        min-width: 0.5rem;
      }
      .audio-img {
        font-size: 0.22rem;
        color: #252631;
        i {
          display: inline-block;
          width: 0.23rem;
          height: 0.23rem;
          background: url("../../assets/img/column_video/volume.png") no-repeat
            center/contain;
          background-size: 100%;
          vertical-align: middle;
          margin-top: -0.05rem;
        }
      }
      .audio-ctr {
        width: 0.55rem;
        height: 0.56rem;
        margin: 0 0.05rem;
        border: none;
      }
      .play {
        background: url("../../assets/img/column_video/audio_play.png")
          no-repeat center/contain;
        background-size: 100%;
      }
      .paused {
        background: url("../../assets/img/column_video/audio_pause.png")
          no-repeat center/contain;
        background-size: 100%;
      }
      .progress-bar-bg {
        display: inline-block;
        width: 3rem;
        height: 0.05rem;
        background: #b5b8b9;
        border-radius: 0.02rem;
        position: relative;
        .progress-bar {
          width: 0;
          height: 0.05rem;
          background: #005587;
        }
        span {
          content: "";
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          background-color: #005587;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -0.1rem;
          margin-right: -0.1rem;
        }
      }
    }
  }
  .no-data {
    .no-img {
      width: 2.75rem;
      height: 2.75rem;
      background: url("../../assets/img/learning_camp/no-data.png") no-repeat
        center/contain;
      background-size: 100%;
      margin: 1rem auto;
    }
    h5 {
      text-align: center;
    }
  }
  .fixed-video-box {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100000;
    .box-pos {
      margin-top: 50%;
      .close-img {
        width: 1rem;
        height: 1rem;
        background: url("../../assets/img/column_video/close@3x.png") no-repeat
          center/contain;
        background-size: 100%;
        margin: 1rem auto;
      }
    }
  }
  .n-class-slide {
    display: none;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
    .class-ctrl {
      position: absolute;
      width: 0.67rem;
      height: 0.67rem;
      text-align: center;
      line-height: 0.55rem;
      top: 0.05rem;
      right: 0.16rem;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
    }
    .class-ctrl.cur {
      background: #005587;
    }

    .class-ctrl.cur:after {
      background-image: url(~@/assets/img/new/menu2.png);
    }
    .class-ctrl:after {
      position: absolute;
      width: 0.4rem;
      height: 0.3rem;
      top: 0.15rem;
      right: 0.14rem;
      background-size: 100% 100%;
      background-image: url(~@/assets/img/new/menu.png);
      content: "";
    }

    .n-class-box {
      position: absolute;
      width: 3.5rem;
      height: 85%;
      right: 0;
      top: 0.7rem;
      font-size: 0.25rem;
    }
    .n-class-box.cur {
      animation: move 0.5s linear;
      animation-fill-mode: forwards;
    }
    @keyframes move {
      0% {
        right: -3.5rem;
      }
      100% {
        right: 0rem;
      }
    }
    .class-2 {
      position: absolute;
      width: 3.5rem;
      height: 100%;
      overflow: auto;
      right: 3.5rem;
      top: 0;
      padding-top: 0.85rem;
      background: #fff;
      border-radius: 0.1rem;
      a {
        display: block;
        width: 2.5rem;
        padding: 0 0.05rem;
        margin: 0 auto;
        text-align: right;
        height: 0.8rem;
        border-bottom: 1px solid #eee;
        line-height: 0.8rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 0.05rem;
        color: #666;
      }
      .class-4 {
        height: 0.8rem;
      }
      .second_all {
        width: 2.5rem;
        margin-left: 0.5rem;
      }
    }

    .class-1 {
      position: absolute;
      width: 3.5rem;
      height: 100%;
      right: 0;
      top: 0;
      background: #eee;
      border-radius: 0.1rem;
      .line {
        height: 0.06rem;
        background: #fff;
      }
      .class-5 {
        position: fixed;
        top: 1.5rem;
        bottom: 1.3rem;
        overflow: auto;
      }
      a {
        display: block;
        width: 3.5rem;
        padding-left: 0.55rem;
        position: relative;
        height: 0.8rem;
        text-align: center;
        line-height: 0.83rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        background: #eee;
        color: #666;
        border: none;
      }
      a.all {
        background: #005587;
        color: #fff;
        font-size: 0.3rem;
        border-radius: 0.05rem 0.05rem 0 0;
        z-index: 222;
        height: 0.8rem;
        margin-bottom: 0.06rem;
      }
      a.cur {
        background: #fff;
      }
      a span {
        position: absolute;
        width: 0.1rem;
        height: 0.17rem;
        line-height: 0.8rem;
        top: 50%;
        margin-top: -0.1rem;
        left: 0.35rem;
        text-align: center;
        background-size: 100% 100%;
        background-image: url(~@/assets/img/new/prev.png);
      }
    }
  }
}
</style>
